import type { CustomControlCode } from '@common/enums';
import { useDefinedContext } from '@frontend/utils/hooks/useDefinedContext';
import type { EditFormContextValue } from './editFormContext';
import type { EditFormSectionInputFieldContextValue } from './editFormSectionInputFieldContext';
import { EditFormContext } from './editFormContext';
import { EditFormSectionInputFieldContext } from './editFormSectionInputFieldContext';

export function useEditFormContext<
    Data extends Record<string, unknown> = Record<string, unknown>,
    TCustomControlCode extends CustomControlCode | undefined = undefined,
    Version extends number = 1,
>(): EditFormContextValue<Data, TCustomControlCode, Version> {
    return useDefinedContext(EditFormContext) as EditFormContextValue<Data, TCustomControlCode, Version>;
}

export function useEditFormSectionInputFieldContext<
    Data extends Record<string, unknown> = Record<string, unknown>,
    TCustomControlCode extends CustomControlCode | undefined = undefined,
    Version extends number = 1,
>(): EditFormSectionInputFieldContextValue<Data, TCustomControlCode, Version> {
    return useDefinedContext(EditFormSectionInputFieldContext);
}
